import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useEffect, useRef, useState } from 'react';
import lottie from 'lottie-web';
export var useLottie = function useLottie(animationContainer, props) {
  var animationData = props.animationData,
    autoplay = props.autoplay,
    initialSegment = props.initialSegment,
    loop = props.loop,
    onComplete = props.onComplete,
    onConfigReady = props.onConfigReady,
    onDOMLoaded = props.onDOMLoaded,
    onDataFailed = props.onDataFailed,
    onDataReady = props.onDataReady,
    onDestroy = props.onDestroy,
    onEnterFrame = props.onEnterFrame,
    onLoadedImages = props.onLoadedImages,
    onLoopComplete = props.onLoopComplete,
    onSegmentStart = props.onSegmentStart;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    animationLoaded = _useState2[0],
    setAnimationLoaded = _useState2[1];
  var animationInstanceRef = useRef();
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    animationInstance = _useState4[0],
    setAnimationInstance = _useState4[1];
  var play = function play() {
    var _animationInstanceRef;
    (_animationInstanceRef = animationInstanceRef.current) === null || _animationInstanceRef === void 0 ? void 0 : _animationInstanceRef.play();
  };
  var stop = function stop() {
    var _animationInstanceRef2;
    (_animationInstanceRef2 = animationInstanceRef.current) === null || _animationInstanceRef2 === void 0 ? void 0 : _animationInstanceRef2.stop();
  };
  var pause = function pause() {
    var _animationInstanceRef3;
    (_animationInstanceRef3 = animationInstanceRef.current) === null || _animationInstanceRef3 === void 0 ? void 0 : _animationInstanceRef3.pause();
  };
  var setSpeed = function setSpeed(speed) {
    var _animationInstanceRef4;
    (_animationInstanceRef4 = animationInstanceRef.current) === null || _animationInstanceRef4 === void 0 ? void 0 : _animationInstanceRef4.setSpeed(speed);
  };
  var goToAndPlay = function goToAndPlay(value, isFrame) {
    var _animationInstanceRef5;
    (_animationInstanceRef5 = animationInstanceRef.current) === null || _animationInstanceRef5 === void 0 ? void 0 : _animationInstanceRef5.goToAndPlay(value, isFrame);
  };
  var goToAndStop = function goToAndStop(value, isFrame) {
    var _animationInstanceRef6;
    (_animationInstanceRef6 = animationInstanceRef.current) === null || _animationInstanceRef6 === void 0 ? void 0 : _animationInstanceRef6.goToAndStop(value, isFrame);
  };
  var setDirection = function setDirection(direction) {
    var _animationInstanceRef7;
    (_animationInstanceRef7 = animationInstanceRef.current) === null || _animationInstanceRef7 === void 0 ? void 0 : _animationInstanceRef7.setDirection(direction);
  };
  var playSegments = function playSegments(segments, forceFlag) {
    var _animationInstanceRef8;
    (_animationInstanceRef8 = animationInstanceRef.current) === null || _animationInstanceRef8 === void 0 ? void 0 : _animationInstanceRef8.playSegments(segments, forceFlag);
  };
  var setSubframe = function setSubframe(useSubFrames) {
    var _animationInstanceRef9;
    (_animationInstanceRef9 = animationInstanceRef.current) === null || _animationInstanceRef9 === void 0 ? void 0 : _animationInstanceRef9.setSubframe(useSubFrames);
  };
  var getDuration = function getDuration(inFrames) {
    var _animationInstanceRef10;
    return (_animationInstanceRef10 = animationInstanceRef.current) === null || _animationInstanceRef10 === void 0 ? void 0 : _animationInstanceRef10.getDuration(inFrames);
  };
  var destroy = function destroy() {
    var _animationInstanceRef11;
    (_animationInstanceRef11 = animationInstanceRef.current) === null || _animationInstanceRef11 === void 0 ? void 0 : _animationInstanceRef11.destroy();
    animationInstanceRef.current = undefined;
  };
  var loadAnimation = function loadAnimation() {
    var _animationInstanceRef12;
    var forcedConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!animationContainer.current) {
      return;
    }
    (_animationInstanceRef12 = animationInstanceRef.current) === null || _animationInstanceRef12 === void 0 ? void 0 : _animationInstanceRef12.destroy();
    var config = _objectSpread(_objectSpread(_objectSpread({}, props), forcedConfigs), {}, {
      container: animationContainer.current
    });
    var animation = lottie.loadAnimation(config);
    setAnimationInstance(animation);
    animationInstanceRef.current = animation;
    setAnimationLoaded(!!animationInstanceRef.current);

    // eslint-disable-next-line consistent-return
    return function () {
      var _animationInstanceRef13;
      (_animationInstanceRef13 = animationInstanceRef.current) === null || _animationInstanceRef13 === void 0 ? void 0 : _animationInstanceRef13.destroy();
      animationInstanceRef.current = undefined;
    };
  };
  useEffect(function () {
    var onUnmount = loadAnimation();
    return function () {
      return onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
    };
  }, [animationData, loop]);
  useEffect(function () {
    if (!animationInstanceRef.current) {
      return;
    }
    animationInstanceRef.current.autoplay = !!autoplay;
  }, [autoplay]);
  useEffect(function () {
    if (!animationInstanceRef.current) {
      return;
    }
    if (!initialSegment) {
      animationInstanceRef.current.resetSegments(true);
      return;
    }
    if (!Array.isArray(initialSegment) || !initialSegment.length) {
      return;
    }
    var _initialSegment = _slicedToArray(initialSegment, 2),
      startFrame = _initialSegment[0],
      stopFrame = _initialSegment[1];
    if (animationInstanceRef.current.currentRawFrame < startFrame || animationInstanceRef.current.currentRawFrame > stopFrame) {
      animationInstanceRef.current.currentRawFrame = startFrame;
    }
    animationInstanceRef.current.setSegment(startFrame, stopFrame);
  }, [initialSegment]);
  useEffect(function () {
    var partialListeners = [{
      handler: onComplete,
      name: 'complete'
    }, {
      handler: onLoopComplete,
      name: 'loopComplete'
    }, {
      handler: onEnterFrame,
      name: 'enterFrame'
    }, {
      handler: onSegmentStart,
      name: 'segmentStart'
    }, {
      handler: onConfigReady,
      name: 'config_ready'
    }, {
      handler: onDataReady,
      name: 'data_ready'
    }, {
      handler: onDataFailed,
      name: 'data_failed'
    }, {
      handler: onLoadedImages,
      name: 'loaded_images'
    }, {
      handler: onDOMLoaded,
      name: 'DOMLoaded'
    }, {
      handler: onDestroy,
      name: 'destroy'
    }];
    var listeners = partialListeners.filter(function (listener) {
      return listener.handler != null;
    });
    if (!listeners.length) {
      return;
    }
    var deregisterList = listeners.map(function (listener) {
      var _animationInstanceRef14;
      // todo: typing
      (_animationInstanceRef14 = animationInstanceRef.current) === null || _animationInstanceRef14 === void 0 ? void 0 : _animationInstanceRef14.addEventListener(listener.name, listener.handler);
      return function () {
        var _animationInstanceRef15;
        (_animationInstanceRef15 = animationInstanceRef.current) === null || _animationInstanceRef15 === void 0 ? void 0 : _animationInstanceRef15.removeEventListener(listener.name, listener.handler);
      };
    });

    // eslint-disable-next-line consistent-return
    return function () {
      deregisterList.forEach(function (deregister) {
        return deregister();
      });
    };
  }, [onComplete, onLoopComplete, onEnterFrame, onSegmentStart, onConfigReady, onDataReady, onDataFailed, onLoadedImages, onDOMLoaded, onDestroy]);
  return {
    animationContainerRef: animationContainer,
    animationItem: animationInstance,
    animationLoaded: animationLoaded,
    destroy: destroy,
    getDuration: getDuration,
    goToAndPlay: goToAndPlay,
    goToAndStop: goToAndStop,
    pause: pause,
    play: play,
    playSegments: playSegments,
    setDirection: setDirection,
    setSpeed: setSpeed,
    setSubframe: setSubframe,
    stop: stop
  };
};